import { BUTTON_SIZE, BUTTON_STYLE, OzButton } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { IDataLayer, IUseGTMDataLayer, useGTMDataLayer } from '../../../shared/useGTMDataLayer';

import { CTA_HREF, ImpactCTATestIds } from './ImpactCTAConstants';

type IImpactCTAProps = {
    title: string;
};

function createCTATracking (title: string): IDataLayer {
    /* eslint-disable camelcase */
    return {
        event: 'click',
        ga_category: 'Impact Article',
        ga_action: 'Click CTA',
        ga_label: title,
        ga_value: 1,
    };
    /* eslint-enable camelcase */
}

export function ImpactCTA (props: IImpactCTAProps): ReactElement {
    const { title }: IImpactCTAProps = props;

    function handleClick (): void {
        const { pushEvent }: IUseGTMDataLayer = useGTMDataLayer(createCTATracking(title));

        pushEvent();
    }

    return (
        <div
            className="px-5 pt-4 pb-2 lg:px-8 bg-navy-900"
            data-testid={ImpactCTATestIds.HOST}
        >
            <div className="text-3xl lg:text-5xl font-bold leading-none mb-2 text-yellow-500">
                Increase your impact
            </div>
            <p className="text-base lg:text-lg font-regular text-white-500 mb-5">
                Find more chances to win-win
            </p>
            <OzButton
                style={BUTTON_STYLE.LINK}
                size={BUTTON_SIZE.MEDIUM}
                data-testid={ImpactCTATestIds.CTA_LINK}
                className="text-lg font-bold text-white-500 uppercase tracking-normal"
                href={CTA_HREF}
                onClick={handleClick}
            >
                EXPLORE OMAZE
            </OzButton>
        </div>
    );
}
